import script from "./SMSCampaignsModalTest.vue?vue&type=script&setup=true&lang=ts"
export * from "./SMSCampaignsModalTest.vue?vue&type=script&setup=true&lang=ts"

import "./SMSCampaignsModalTest.vue?vue&type=style&index=0&id=a98b18d0&lang=scss"

const __exports__ = script;

export default __exports__